import {apiMemberserviceEndpoint} from '@/config/config.js';
import { createApiClient } from "@/services/baseservice.js"

const apiScope = 'api://memberservice-api/Member.Read'
//const apiScope ='api://91073084-ee2e-446e-a85d-95d69db36770/Member.Read'

const baseservice = createApiClient(apiScope, apiMemberserviceEndpoint)

export default {
    async getAll() {
        return await baseservice.get('/members/active',
            { baseURL: apiMemberserviceEndpoint });
    },
    async getConfig() {
        return await baseservice.get('/config',
            { baseURL: apiMemberserviceEndpoint })
    },

    async getCount() {
        return await baseservice.get('/members/active/count',
            { baseURL: apiMemberserviceEndpoint })
    },
    async update(memberId, member) {
        return await baseservice.put('/members/' + memberId, member,
            { baseURL: apiMemberserviceEndpoint })
    },
    async deleteMember(memberId) {
        return await baseservice.delete('/members/' + memberId,
            { baseURL: apiMemberserviceEndpoint })
    },
    async getByFirstAndLastname(firstname, lastname) {

        let apiRes = null;
        try {
            apiRes = await baseservice.get('/members/name/' + firstname + '/' + lastname,
                { baseURL: apiMemberserviceEndpoint })
        } catch (err) {
            apiRes = err.response;
        } finally {
            //console.log(apiRes); // Could be success or error
        }

        return apiRes
    }
};
